import { Container } from "react-bootstrap";

function Startseite(props) {
    return (
        <>
           <Container style={{ marginTop : 100 }}>
                <h1>Aktuelles</h1>
           </Container>
           <Container>
           <p style={{textAlign: "left"}}>Medway Recruitment ist Ihr zuverlässiger und kompetenter Partner für die Vermittlung hochqualifizierter medizinischer Fachkräfte aus Tunesien. 
            Unser erfahrenes Expertenteam unterstützt Gesundheitseinrichtungen bei der Rekrutierung spezialisierter Pflege- und Fachkräfte, 
            indem es individuelle Lösungen für den jeweiligen Personalbedarf entwickelt. Dank fundierter Fachkenntnisse, langjähriger Branchenerfahrung und eines internationalen Netzwerks gewährleisten wir eine professionelle Beratung und eine effiziente Besetzung offener Positionen. 
            Kontaktieren Sie uns, 
            um von maßgeschneiderten Rekrutierungskonzepten und höchster Servicequalität zu profitieren.</p>
           </Container>
           
       
        </>
    ) 
}
export default Startseite;